/*jslint browser */
/*global process */

import AttributeManager from "../model/attribute/attribute.manager";

var $ = jQuery;

/**
 *
 */
export default class AttributesController
{
    private _settings: any;
    private _colourBox: JQuery;
    private _variationsSelect: JQuery;
    private _resetVariations: JQuery;
    private _attributeManager: AttributeManager;

    /**
     *
     */
    constructor(settings: any)
    {
        this._settings = settings;
        this._attributeManager = new AttributeManager();
    }

    public attributesAction(): void
    {
        this.registerEvents();
    }

    /**
     *
     * @private
     */
    private registerEvents(): void
    {
        this._colourBox = $('.colour-box');
        this._variationsSelect = $('.variations select');
        this._resetVariations = $('.reset_variations');

        this._colourBox.on('click', (e) => {
            this.colourBoxClick($(e.currentTarget));
        })

        this._variationsSelect.on('change', (e) => {
            this.variationsSelectChange();
        })

        this._resetVariations.on('click', (e) => {
            this.resetVariationsClick();
        })
    }

    private colourBoxClick(ob: JQuery): void {
        this._attributeManager.changeColourAttributeValue(ob);
    }

    private variationsSelectChange(): void {
        this._attributeManager.refreshColourAttributeValue();
    }

    private resetVariationsClick(): void {
        this._attributeManager.resetAttribute();
    }
}